import { Entity } from '@backstage/catalog-model';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

// Mirror the backend's namespace resolution (see plugins/kubernetes/domain/catalog.ts):
// without one of these annotations the /workloads call 404s, so only surface the
// tab on components that can actually resolve a namespace.
const NS_ANNOTATION = 'backstage.io/kubernetes-namespace';
const ID_ANNOTATION = 'backstage.io/kubernetes-id';

const squadK8sContent = EntityContentBlueprint.make({
  name: 'squad-k8s',
  params: {
    path: '/kubernetes',
    title: 'Kubernetes',
    filter: (entity: Entity) =>
      entity.kind === 'Component' &&
      Boolean(
        entity.metadata.annotations?.[NS_ANNOTATION] ??
          entity.metadata.annotations?.[ID_ANNOTATION],
      ),
    loader: async () => {
      const { SquadK8sContent } = await import('./SquadK8sContent');
      return <SquadK8sContent />;
    },
  },
});

export const squadK8sModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [squadK8sContent],
});
